<div class="container container-wrapper page-container">
  <div class="row justify-content-center">
    <div class="col-12 col-xl-11">
      <div class="row justify-content-center align-content-center art-group page-container-content">
        <div class="col-12 col-xl-11">
          <app-giftcard-list *ngIf="!loading" class="row justify-content-center"></app-giftcard-list>
        </div>
      </div>
      <div class="row">
        <div class="col-12 p-0">
          <div class="container p-0">
            <span>
              <app-backward-forward (backwardClick)="onBack()" [hideNext]="true" [hideBack]="hideBack">
              </app-backward-forward>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
